import {
  Modal,
  Button,
  CloseButton
} from 'react-bootstrap';

function PopupAlert(props) {
  const {
    show,
    handleSubmit,
    handleClose,
    display_text,
    hasClose = false,
    btn_text
  } = props;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      keyboard={true}
    >
      <Modal.Body
        className="custom_body"
      >
        <div onClick={handleClose} className="close_modal"><CloseButton title="Close" /></div>
        <div className="text-center">
          <div className="mb-4">{display_text}</div>
          <div className="d-flex align-items-center justify-content-center">
            {
              hasClose && (
                <Button
                variant="default"
                size="sm"
                onClick={handleClose}
                className="px-3"
              >
                Cancel
              </Button>
              )
            }

            <Button
              variant="primary"
              size="sm"
              onClick={handleSubmit}
              className="mx-3 px-3"
            >
              {btn_text ? btn_text : 'OK'}
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export { PopupAlert };
